module.exports = __webpack_public_path__ + "static/media/service-web-development.b53e6836.png";